import React from 'react'
import { StyleSheet, View } from 'react-native'
import { Button } from '@ui-kitten/components'
import { useTranslation } from 'react-i18next'

const LABEL_KEYS = {
  add_product: 'support.quickReplyAddProduct',
  new_sale: 'support.quickReplyNewSale',
}

/**
 * ACT-QUICK-REPLY-001 — the welcome's action buttons, under its bubble. Each one opens the screen
 * it names; none of them sends a message. `replies` is already filtered to what this person can use.
 */
export default function WelcomeQuickReplies({ messageId, replies, onQuickReply }) {
  const { t } = useTranslation()
  if (!replies?.length || !onQuickReply) return null
  return (
    <View style={styles.row} testID="support-welcome-quick-replies">
      {replies.map((reply) => (
        <Button
          key={reply}
          size="small"
          appearance="outline"
          style={styles.button}
          onPress={() => onQuickReply({ messageId, reply })}
          testID={`support-quick-reply-${reply}`}
        >
          {t(LABEL_KEYS[reply])}
        </Button>
      ))}
    </View>
  )
}

const styles = StyleSheet.create({
  row: { flexDirection: 'row', flexWrap: 'wrap', paddingHorizontal: 14, marginTop: 2, marginBottom: 6, gap: 8 },
  button: { borderRadius: 18 },
})
